
import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import {setSelectedCoin} from '../../../actions/ui/index';
import coinsExtended from '../../../selectors/coinsExtended';
import {CoinsList} from '../../coinslist/index';

import './styles.css'

class Mob extends PureComponent {

  selectCoin = (id) => {
    this.props.setSelectedCoin(id)
    this.props.history.push('/mob/coins/' + id)
  }

  render = () => {
    return (
      <fb className="coins-list-wrapper">
        <CoinsList
          selectCoin={this.selectCoin}
          editCoin={()=>{}} // edit is only from desktop version ( for admins )
          coins={this.props.coins}
        />
      </fb>
    )
  }
}

const mapDispatchToProps = {
  setSelectedCoin
}

const mapStateToProps = (state: Store) => ({
  coins: coinsExtended(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Mob)



// WEBPACK FOOTER //
// ./src/containers/mob/listView/index.js